import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import DefinicionVariable from "../ActualizacionPrecio/DefinicionVariable";
import { UrlApi } from "../../../../services/apirest";
import moment from "moment";

function DialogPrecioParticular({ open, setOpen, onClose, row }) {
  const [monto, setMonto] = useState("");
  const [porcentaje, setPorcentaje] = useState("");
  const [precioMinimo, setPrecioMinimo] = useState("");
  const [precioMaximo, setPrecioMaximo] = useState("");
  const [tipoOperacion, setTipoOperacion] = useState("");

  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  const validarInput = (value) => /^-?\d*\.?\d*$/.test(value);
  const handleMontoChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setMonto(value);
      if (value !== "") setPorcentaje("");
      setTipoOperacion("monto");
    }
  };

  const handlePorcentajeChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPorcentaje(value);
      if (value !== "") setMonto("");
      setTipoOperacion("porcentaje");
    }
  };

  const handlePrecioMinimo = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPrecioMinimo(value);
      if (value !== "") setMonto("");
      setTipoOperacion("precio");
    }
  };

  const handlePrecioMaximo = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPrecioMaximo(value);
      if (value !== "") setMonto("");
      setTipoOperacion("precio");
    }
  };

  const handleClose = () => {
    onClose(false);
  };

  const handleActualizarPrecios = async (e) => {
    e.preventDefault();

    const valor = parseFloat(monto || porcentaje);
    let nuevoMin = row.precio_minimo;
    let nuevoMax = row.precio_maximo;

    if (tipoOperacion === "monto") {
      nuevoMin += valor;
      nuevoMax += valor;
    } else if (tipoOperacion === "porcentaje") {
      const factor = valor / 100;
      nuevoMin += nuevoMin * factor;
      nuevoMax += nuevoMax * factor;
    } else {
      nuevoMin = precioMinimo;
      nuevoMax = precioMaximo;
    }

    const actualizado = {
      id: row.id,
      precio_minimo: Math.round(nuevoMin),
      precio_maximo: Math.round(nuevoMax),
    };

    try {
      // Primero actualizo el precio
      const resp = await fetch(
        UrlApi + "/envasado_rango_precios/xID/" + actualizado.id,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            precio_minimo: actualizado.precio_minimo,
            precio_maximo: actualizado.precio_maximo,
          }),
        },
      );

      const data = await resp.json();

      if (!data.err) {
        console.log("Guardado");

        // Armo el historial (solo un registro)
        const historial = {
          producto: row.producto,
          sucursal: row.sucursal,
          precio_minimo_anterior: row.precio_minimo,
          precio_maximo_anterior: row.precio_maximo,
          precio_minimo_nuevo: actualizado.precio_minimo,
          precio_maximo_nuevo: actualizado.precio_maximo,
          fecha: moment().format("YYYY-MM-DD"),
          usuario: localStorage.getItem("user"),
        };

        // Guardo en historial
        await fetch(`${UrlApi}/envasado_historial_rango`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(historial),
        });

        setOpenSnack(true);
        setColorMensaje("#D4EFDF");
        setMensaje("La variación se guardó exitosamente !");
      } else {
        console.log("Error");
      }
    } catch (err) {
      console.error("Error actualizando precios", err);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth={"xl"}>
        <form
          onSubmit={handleActualizarPrecios}
          style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
        >
          <Box bgcolor="#1F618D">
            <DialogTitle
              sx={{
                bgcolor: "#1F618D",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                position: "relative",
                p: 1,
              }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{
                  flexGrow: 1,
                  textAlign: "center",
                  pr: 4,
                }}
              >
                Actualizar Precio
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent sx={{ p: 1.8 }}>
            <DefinicionVariable
              monto={monto}
              porcentaje={porcentaje}
              precioMinimo={precioMinimo}
              precioMaximo={precioMaximo}
              handleMontoChange={handleMontoChange}
              handlePorcentajeChange={handlePorcentajeChange}
              handlePrecioMinimo={handlePrecioMinimo}
              handlePrecioMaximo={handlePrecioMaximo}
            />
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "space-between",
              p: 1,
              position: "sticky",
              bottom: 0,
            }}
          >
            <Button
              color="error"
              variant="contained"
              onClick={handleClose}
              sx={{ minWidth: 120 }}
            >
              Volver
            </Button>

            <Button
              color="success"
              type="submit"
              variant="contained"
              sx={{ minWidth: 120 }}
            >
              Confirmar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default DialogPrecioParticular;
